import { PropTypes } from 'prop-types'
import { toast } from 'react-toastify'

const useToast = () => {
    const showToast = (text, type) => {

        let errorText = text.split('\r\n')

        const hata = (
            <div>
               {errorText?.map((err,i) => (
                <div key={i}>
                  {err}
                </div>
               ))}
            </div>
        )
        switch (type) {
            case 'success':
                toast.success(text)
                break
            case 'error':
                toast.error(hata)
                break
            case 'warning':
                toast.warning(text)
                break
            default:
                toast(text)
                break
        }
    }
    return { showToast }
}

useToast.propTypes = {
    text: PropTypes.string,
    type: PropTypes.string,
}

export default useToast
